"use client";

/**
 * A localized link to the sign-in / sign-up flow that automatically
 * carries the current page as `return_to`, so the visitor lands back
 * exactly where they were (incl. query like `?layer=zones`) afterwards.
 * Use anywhere an anonymous user is nudged to authenticate.
 */
import type { ReactNode } from "react";
import Link from "@/lib/localized-link";
import { useAuthHref } from "@/lib/use-return-to";

export default function AuthLink({
  target = "login",
  className,
  children,
}: {
  target?: "login" | "register";
  className?: string;
  children: ReactNode;
}) {
  const href = useAuthHref(target);
  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
}
